// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackQuantityChangedInQuickOrderParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackQuantityChangedInQuickOrder";

const useTrackQuantityChangedInQuickOrder = (
    parameters: TrackQuantityChangedInQuickOrderParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.quantityChangedInQuickOrder, parameters, options);
};

export default useTrackQuantityChangedInQuickOrder;
